<script setup>
import { useAlertStore } from "~/stores/useAlertStore.js";

const { alerts } = useAlertStore();
</script>

<template>
  <div
    style="
      z-index: 20001;
      position: fixed;
      display: grid;
      grid-gap: 0.5em;
      bottom: 10px;
      right: 10px;
    "
  >
    <v-slide-x-transition group>
      <v-alert v-for="alert in alerts" :key="alert[1].id" :type="alert[1].type">
        {{ alert[1].message }}
        <ul v-if="!!alert[1].errors.length">
          <li v-for="(error, index) in alert[1].errors" :key="index">
            <span v-if="error.verbose_name"
              ><b
                ><u>{{ error.verbose_name }}:&nbsp;</u></b
              >
            </span>
            <span v-else
              ><b><u>Errore:&nbsp;</u></b></span
            >
            {{ error.detail }}
          </li>
        </ul>
      </v-alert>
    </v-slide-x-transition>
  </div>
</template>
